module.exports = __webpack_public_path__ + "img/bike_card_7_navbar_bg.8ab76525.png";